<template>


  <div  class="modal fade" ref="modal-Fogot-Password" id="ForgotPasswordModal" >

    <!--=======================Sending email content=======================================-->

    <div v-if="confirmModal&&!changePasswModal&&!messageBox" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header dark-bg">
          <div class="col-auto me-auto ">
            <h3>Przypomnienie hasła</h3>
          </div>
          <div class="col-auto d-flex align-items-center">
            <button type="button" class="btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <form @submit.prevent="" class="col-10">
            <div class="PopupLogin">
              <i class="fas fa-envelope"></i>

              <input ref="input" type="text" class="form-control " placeholder="Email" :class="{

                          'is-invalid': $v.reset_email.$invalid && $v.reset_email.$dirty,
                          'is-valid': !$v.reset_email.$invalid && $v.reset_email.$dirty

                        }" v-model="reset_email"  @keyup.enter="change" @input="$v.reset_email.$touch();"> <br>


            </div>
            <div class="PopupError" style="text-align: left">
              <p v-if="$v.reset_email.$invalid && $v.reset_email.$dirty " style="color:red;" class="validatePassword">* Email nie może być pusty</p>
            </div>


<!--          <pre>
         {{creds}}


         {{reset_email}}
        </pre>  -->



        </form>
        </div>
        <div class="modal-footer d-flex justify-content-evenly">
          <form>
            <b-col lg="4" class="pb-2">
              <a class="form-button btn btn-outline-primary-o btn-lg me-2 login" :class="{ disabled:$v.reset_email.$invalid  }" data-bs-dismiss="modal" @click="change" style="background-color: transparent">Wyślij</a>
            </b-col>
          </form>
        </div>
      </div>
    </div>

    <!--=======================message box content=======================================-->

    <div v-else-if="!confirmModal&&!changePasswModal&&messageBox" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header dark-bg">
          <div v-if="emailSend" class="col-auto me-auto ">
            <h3>Potwierdzenie</h3>

          </div>
          <div v-else-if="reject" class="col-auto me-auto ">
            <h3>Odmowa</h3>
          </div>
          <div v-if="changedPassword" class="col-auto me-auto ">
            <h3>Powodzenie</h3>
          </div>
          <div class="col-auto d-flex align-items-center">
            <button type="button" class="btn-close btn-close" @click="goBackToBeg" aria-label="Close"></button>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <form class="col-10">
            <div v-if="emailSend" class="PopupLogin" style="font-size: 20px; color: #045439; padding: 20px;">
              Wiadomość z linkiem potwierdzającym została wysłana na Twoją pocztę
            </div>
            <div v-else-if="reject" class="PopupLogin" style="font-size: 20px; color: #045439; padding: 20px;">
              Przepraszamy, zmiana hasła nie jest możliwa
            </div>
            <div v-else-if="changedPassword" class="PopupLogin" style="font-size: 20px; color: #045439; padding: 20px;">
              Twoje hasło zostało zmienione
            </div>
          </form>
        </div>
        <div class="modal-footer d-flex justify-content-evenly">
          <form>
            <b-col lg="4" class="pb-2">
              <a class="form-button btn btn-outline-primary-o btn-lg me-2 login" data-bs-dismiss="modal" @click="goBackToBeg">OK</a>
            </b-col>
          </form>
        </div>
      </div>
    </div>

    <!--=======================Changing password content=======================================-->

    <div v-else-if="!confirmModal&&changePasswModal&&!messageBox" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header dark-bg">
          <div class="col-auto me-auto ">
            <h3>Zmiana hasła</h3>
          </div>
          <div class="col-auto d-flex align-items-center">
            <button type="button" class="btn-close btn-close" @click="goBackToBeg" aria-label="Close"></button>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <form @submit.prevent="" class="col-10 mt-3">

            <!--=======================Input password and second same password=======================================-->
            <div class="PopupHaslo ">

              <input ref="input" type="password" class="form-control " placeholder="Nowe hasło" :class="{

                          'is-invalid': $v.creds.passw.$invalid && $v.creds.passw.$dirty,
                          'is-valid': !$v.creds.passw.$invalid && $v.creds.passw.$dirty

                        }" v-model="creds['passw']"  @keyup.enter="changePassw" @input="$v.creds.passw.$touch();"> <br>

            </div>


            <div class="PopupHaslo ">
              <input ref="input" type="password" class="form-control " placeholder="Powtórz hasło" :class="{

                          'is-invalid': $v.creds.passw_conf.$invalid && $v.creds.passw_conf.$dirty,
                          'is-valid': !$v.creds.passw_conf.$invalid && $v.creds.passw_conf.$dirty

                        }" v-model="creds['passw_conf']"  @keyup.enter="changePassw" @input="$v.creds.passw_conf.$touch();"> <br>
            </div>

            <div class="PopupError">
              <p v-if="$v.creds.passw.$invalid && $v.creds.passw.$dirty " style="color:red;" class="validatePassword">* Wprowadź nowe hasło - min. 6 znaków , znak specjalny , Dużą i małą litere</p>
              <p v-if="$v.creds.passw_conf.$invalid && $v.creds.passw_conf.$dirty" style="color:red;" class="validatePassword">* Wprowadzone ponownie nowe hasło nie jest takie samo</p>

            </div>
          </form>
        </div>
        <div class="modal-footer d-flex justify-content-evenly">
          <form>
            <b-col lg="4" class="pb-2">
              <a class="form-button btn btn-outline-primary-o btn-lg me-2 login" :class="{ disabled:$v.creds.passw.$invalid || $v.creds.passw_conf.$invalid  }" @click="changePassw" style="background-color: transparent">Zmień</a>
            </b-col>
          </form>
        </div>
      </div>
    </div>
    <!--=======================================================================================================-->

    <div v-else-if="stepFail" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header dark-bg">
          <div class="col-auto me-auto ">
            <h3>Info</h3>
          </div>
          <div class="col-auto d-flex align-items-center">
            <button type="button" class="btn-close btn-close" aria-label="Close" @click="goBackToBeg"></button>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <form>
            <div class="PopupLogin col-10" style="font-size: 20px; color: #045439; padding: 20px;">
              Zaloguj się na swoje konto
            </div>
          </form>
        </div>
        <div class="modal-footer d-flex justify-content-evenly">
          <form>
            <b-col lg="4" class="pb-2">
              <a class="form-button btn btn-outline-primary-o btn-lg me-2 login" data-bs-dismiss="modal" @click="goBackToBeg">OK</a>
            </b-col>
          </form>
        </div>
      </div>
    </div>

    <!--=======================================================================================================-->
    <!--=======================================================================================================-->

    <div v-else-if="thankYouModal" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header dark-bg">
          <div class="col-auto me-auto ">
            <h3>Info</h3>
          </div>
          <div class="col-auto d-flex align-items-center">
            <button type="button" class="btn-close btn-close" aria-label="Close" @click="goBackToBeg"></button>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <form class="col-10">
            <div class="PopupLogin" style="font-size: 20px; color: #045439; padding: 20px;">
              Dziękujemy za skorzystanie z naszej oferty.
            </div>
          </form>
        </div>
        <div class="modal-footer d-flex justify-content-evenly">
          <form>
            <b-col lg="4" class="pb-2">
              <a class="form-button btn btn-outline-primary-o btn-lg me-2 login" data-bs-dismiss="modal" @click="goBackToBeg">OK</a>
            </b-col>
          </form>
        </div>
      </div>
    </div>

    <!--=======================================================================================================-->
  </div>
</template>
<script>
  import { required, minLength, between , sameAs, email} from 'vuelidate/lib/validators'

  export default {
    data(){
      return{
        //input value
        creds: {},


        reset_email: '',

        //token ,,code="
        token:'',
        //email after decoding
        email_from_token:'',
        //modal
        modal:null,
        //client email
        email:'',
        stepFail:false,
        thankYouModal:false,
        //which modal should open
        //sending email content
        confirmModal:true,
        //changing password content
        changePasswModal:false,
        //message box content
        messageBox:false,
        //message box content
        //message after email is send
        emailSend:true,
        //message with reject
        reject:false,
        //changed password message
        changedPassword:false


      }
    },
    //====================
    //validate input value
    //====================
    validations(){

      return {
        creds: {

          passw: {
            required,
            minLength: minLength(6),
            passwordPolicy: this.passwordPolicy
          },

          passw_conf: {
            required,
            sameAsPassword: sameAs('passw'),
          },

          email_creds:{
            required,
            email: email
          }
        },

        reset_email:{
          required,
          email: email
        }
      }
    },

    //========================================================
    //Second step , sending token and client email to database
    //========================================================

    created(){
      this.listen('ForgotPasswordModal', (v) => {

        let decoded=''
        if(v!=="stepFail" && v!=="thankYouModal")
          decoded=eval(window.atob(unescape(encodeURIComponent( v ))));
        /*console.log(decoded[0]);
        console.log(decoded[1]);*/
        /* console.log(v)*/
        if(v==="stepFail"){

          this.changePasswModal = false;
          this.confirmModal = false;
          this.messageBox = false;
          this.stepFail = true;
          this.modal.show();

        }
        else if(v==="thankYouModal"){
          this.changePasswModal = false;
          this.confirmModal = false;
          this.messageBox = false;
          this.stepFail = false;
          this.thankYouModal=true;
          this.modal.show();
        }
        else {
          this.patch('client/password', {client_email: decoded[0], client_code: decoded[1]}).then(response => {
            if (!!response.data) {
              if (!(response.data.IS_ERROR | 0)) {
                /*console.log("token jest poprawny");*/
                this.email_from_token = decoded[0];
                this.token = decoded[1];
                this.changePasswModal = true;
                this.confirmModal = false;
                this.messageBox = false;
                this.modal.show();
              } else {
                /*console.log("token jest niepoprawny");*/
                this.confirmModal = false;
                this.changePasswModal = false;
                this.messageBox = true;
                this.emailSend = false;
                this.reject = true;
                this.changedPassword = false;
                this.modal.show();
              }
            }
          })
            .catch(error => {
              if (error.response) {
                this.confirmModal = false;
                this.changePasswModal = false;
                this.messageBox = true;
                this.emailSend = false;
                this.reject = true;
                this.changedPassword = false;
                this.modal.show();
              }
            });

        }
      });
    },
    mounted(){
      this.modal = new bootstrap.Modal(this.$refs['modal-Fogot-Password']);
    },
    methods:{

      //=======================
      //Close message box modal
      //=======================

      CloseMessageBox(){
        this.modal.hide();
        setTimeout(()=>{
          if(this.messageBox&&this.emailSend || this.stepFail){
            this.confirmModal = true;
            this.changePasswModal = false;
            this.messageBox=false;}
        }, 1000)

      },

      //======================================
      //First step , sending email to database
      //======================================

      change()
      {
        this.modal.hide()
        this.put('client/password', {client_email:this.reset_email}).then(response => {
          /*console.log(response.data)*/
          if (!!response.data) {
            /*console.log(response.data.IS_ERROR)*/
            if ( !(response.data.IS_ERROR | 0)) {
              /*console.log('its ok email is error = 0')*/
            }
            /*else console.log("email jest niepoprawny")*/

          }
          /*else console.log("co tu jest grane")*/

        })
          .catch(error => {

          });



        setTimeout(() => {

          this.confirmModal = false;
          this.changePasswModal = false;
          this.messageBox=true;
          this.modal.show()
        }, 700)
      },

      //=============================================================
      //Third step, showing changing password content modal or reject
      //=============================================================

      changePassw() {
        /* console.log(this.email_from_token);
         console.log(this.token);
         console.log(this.passw);*/
        this.patch('client/password', {
          client_email: this.email_from_token,
          client_code: this.token,
          client_password: this.creds['passw']

        }).then(response => {
          /*console.log(response.data + " asdasdas");
            console.log(this.passw)*/
          if (!!response.data) {
            if (!(response.data.IS_ERROR | 0)) {
              /*console.log("token jest poprawny");*/
              this.confirmModal = false;
              this.changePasswModal = false;
              this.messageBox = true;
              this.emailSend = false;
              this.reject = false;
              this.changedPassword = true;
            } else {
              /*console.log("token jest niepoprawny");*/
              this.confirmModal = false;
              this.changePasswModal = false;
              this.messageBox = true;
              this.emailSend = false;
              this.reject = true;
              this.changedPassword = false;
            }
          }
        })
          .catch(error => {
            if (error.response) {
              this.confirmModal = false;
              this.changePasswModal = false;
              this.messageBox = true;
              this.emailSend = false;
              this.reject = true;
              this.changedPassword = false;
            }
          });

        this.$v.$reset();
      },
      //=========================

      goBackToBeg(){
        this.modal.hide();
        setTimeout(()=>{

          this.$v.$reset();
          this.creds.email_creds='';
          this.confirmModal=true;
          this.changePasswModal=false;
          this.messageBox=false;
          this.emailSend=true;
          this.reject=false;
          this.changedPassword=false;




        },1000)

      }
    },
    computed:{
      //====================
      //checking input value
      //====================
      invalidPassword() {
        return this.isDirty && !this.creds['passw']
      },

      invalidCreds() {
        return this.isDirty
      }
      //====================
    }
  }
</script>
<style scoped>
  .modal.fade .modal-dialog {
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    transform: translate(0, 0);

  }


  a.login {

    width:16rem;
  }

  .PopupLogin{
    position: relative;
    padding-top: 1rem;
  }

  .PopupLogin input, .PopupHaslo input {
    padding-right: 35px !important;
  }

  .PopupLogin i,  .PopupHaslo i {
    opacity: .5;
    position: absolute;
    right: 1rem;
    padding: 17px 20px;
    pointer-events: none;
  }

  PopupHaslo i:invalid {
    opacity: .5;
    position: absolute;
    right: 3rem;
    padding: 17px 20px;
    pointer-events: none;
  }




  .modal-footer {
    justify-content: left;
  }



  b-button {
    width: 250px;
    height: 40px;
    color: white;
    background-color: forestgreen;
    display: flex;
    justify-content: center;
  }





  h5 {
    justify-content: center;
  }

  .modal-dialog {
    overflow-y: initial;
    display: flex;
    justify-content: center;
    max-width:700px;
  }

  .modal-header {
    display: flex;
    justify-content: center;
    overflow-y: auto;

    text-align:center;

  }
</style>



// WEBPACK FOOTER //
// src/components/ForgotPasssword.vue